import {useNavigate, useLocation, useParams} from 'react-router'
import {longArrowLeft} from '@img/index.js'
import useMinimalLayout from '@/hooks/useMinimalLayout.js'

/**
 * Back button for the ride edit / confirm pages. It used to live in the dashboard
 * Header; it now sits beside the page title, so both pages render it themselves.
 *
 * location.key is 'default' only on the first entry (e.g. landing straight from the
 * external booking portal) — there's no in-app history to pop, so navigate(-1) would
 * leave the portal. Fall back to the trip details page.
 *
 * NOT RENDERED on a staff-handoff link (`?layout=minimal`). That flag strips the
 * dashboard chrome — no sidebar, no header — because the passenger arrived from an SMS
 * with one job: review this booking and confirm it. Back belongs to the chrome, so it
 * goes with it. (It used to survive, pointed at the dashboard home, as a way INTO the
 * portal; that made it the one piece of navigation on an otherwise navigation-free page
 * and a way to lose the booking they were sent to confirm.)
 */
export default function RideBackButton({className = ''}) {
    const navigate = useNavigate()
    const location = useLocation()
    const {rideId} = useParams()
    const minimal = useMinimalLayout()

    if (minimal) return null

    const handleBack = () => {
        if (location.key === 'default') {
            navigate(`/rides/${rideId}`)
        } else {
            navigate(-1)
        }
    }

    return (
        <button type="button" onClick={handleBack} aria-label="Go back"
                className={`cursor-pointer flex items-center justify-center w-10 h-10 rounded-full bg-white border-0 shadow-[0px_4px_32px_0px_rgba(32,30,32,0.08)] ${className}`}>
            <img alt="Go back" src={longArrowLeft}/>
        </button>
    )
}
